import {useState, useEffect} from 'react';
import {shallowEqual} from 'react-redux';
import useTypedSelector from './useTypedSelector';
import {DEFAULT_MEDIUM_SIZE, DEFAULT_LARGE_SIZE} from '../scss/util/variable';

export default function useScreenType() {
  const isAppMounted = useTypedSelector(state => state.common.isAppMounted);
  const [screenTypes, setScreenTypes] = useState(
    getScreenTypes(isAppMounted ? window.innerWidth : 0)
  );
  useEffect(() => {
    const onResize = () => {
      const newScreenTypes = getScreenTypes(window.innerWidth);
      !shallowEqual(newScreenTypes, screenTypes) &&
        setScreenTypes(newScreenTypes);
    };
    window.addEventListener('resize', onResize);
    onResize();
    return () => window.removeEventListener('resize', onResize);
  }, [screenTypes]);
  return screenTypes;
}

function getScreenTypes(width: number): {
  screenType: 'lg' | 'md' | 'sm';
  isSmall: boolean;
  isMedium: boolean;
  isLarge: boolean;
} {
  // TODO: Modal의 contentStyle을 사용하는 컴포넌트는 Responsive 컴포넌트로 사용하기
  const isSmall = width < DEFAULT_MEDIUM_SIZE;
  const isMedium = width >= DEFAULT_MEDIUM_SIZE && width < DEFAULT_LARGE_SIZE;
  const isLarge = width >= DEFAULT_LARGE_SIZE;
  return {
    screenType: isLarge ? 'lg' : isMedium ? 'md' : 'sm',
    isSmall,
    isMedium,
    isLarge,
  };
}
